import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
import { DialerService } from "../dialer.service";
import { Subscription, switchMap } from 'rxjs';
import { NgxTippyService } from "ngx-tippy-wrapper";
import { AuthService } from "app/core/auth/auth.service";

@Component({
    selector: 'dialer-button',
    standalone: true,
    imports: [SharedModule],
    templateUrl: './dialer-button.component.html',
    styleUrls: ['./dialer-button.component.scss']
})
export class DialerButtonComponent implements AfterViewInit, OnDestroy {
    isAudioPermissionGiven: boolean = false;
    @ViewChild('dialerOrigin') set _dialerOrigin(elementRef: ElementRef<HTMLButtonElement>) {
        if (elementRef) {
            this._dialerService.dialerOriginSub$.next(elementRef);
        }
    };
    currentUserStatus: string = 'ONLINE'
    showDialerButton: boolean = false;
    isUserOnCallOtherTab: boolean = false;
    integrations: any;
    toggleOverlay: boolean = false;
    isDialerOverlayReady: boolean = false;
    subs$: Subscription[] = [];
    tippyInstance: any;

    constructor(readonly _dialerService: DialerService, readonly _tippyService: NgxTippyService, readonly _authService: AuthService) {
        this.isUserOnCallOtherTab = this._dialerService.isUserOnCallOtherTabStatus;
        this.isDialerOverlayReady = this._dialerService.isDialerReady;
    }

    ngAfterViewInit(): void {
        this._tippyService.getInstance('dialer_tooltip').disable();
        this._authService.isZuperAgentEnabled$.pipe(
            switchMap(() => this._dialerService.fetchDialerIntegrations())
        ).subscribe((integrations: any) => {
            this.integrations = integrations;
            if (Object.keys(integrations).length > 0) {
                this.showDialerButton = true;
            }
        });
        const dialEvents$ = this._dialerService.callEvents.subscribe((eventData: any) => {
            if (!eventData.eventType) { return; }
            if (eventData.eventType === 'agent_status') {
                this.currentUserStatus = eventData.status;
                this.updateToolTipState()
            }

            if (eventData.eventType === 'audio_permission') {
                this.isAudioPermissionGiven = eventData.state === 'granted'
                this.updateToolTipState()
            }
        });
        const overlayHiddenSub$ = this._dialerService.overlayHiddenSub$.subscribe((isHidden) => {
            this.toggleOverlay = !isHidden;
        })
        const onOtherTabCallSub$ = this._dialerService.isUserOnCallOtherTab.subscribe((status: boolean) => {
            this.isUserOnCallOtherTab = status;
        })
        const dialerOverlayReadySub$ = this._dialerService.isDialerOverlayReady.subscribe((status: boolean) => {
            this.isDialerOverlayReady = status;
        })
        this.subs$ = [dialEvents$, overlayHiddenSub$, onOtherTabCallSub$, dialerOverlayReadySub$]
    }

    togglePanel(toggle: boolean) {
        this.toggleOverlay = toggle;
        this._dialerService.toogleDialerSub$.next(toggle);
    }

    get tooltipText(): string {
        if (!this.isAudioPermissionGiven) {
            return 'Microphone permission needed. Allow permissions in your browser to make or receive calls';
        }

        if (this.currentUserStatus === 'BUSY') {
            const suffix = this.isUserOnCallOtherTab ? 'Switch to Active tab' : '';
            return `Call in progress. ${suffix}`;
        }

        return 'You are unavailable. No calls will be received';
    }

    get dialerIcon(): string {
        if (!this.isAudioPermissionGiven) {
            return 'tabler:phone';
        }
        return this.currentUserStatus === 'ONLINE' ? 'tabler:phone-call' : 'tabler:phone';
    }

    ngOnDestroy() {
        if (this.subs$.length > 0) {
            this.subs$.forEach(sub$ => sub$.unsubscribe());
        }
    }

    updateToolTipState() {
        if (this.currentUserStatus === 'ONLINE' && this.isAudioPermissionGiven) {
            this._tippyService.getInstance('dialer_tooltip').disable();
        } else {
            this._tippyService.getInstance('dialer_tooltip').enable();
        }
    }

}